export default __webpack_public_path__ + "static/media/girl.93f7bae5.png";